"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chbPlanCodeToPlan = exports.chbPlanCodes = exports.isPlan = exports.isSelfHostedPlan = exports.isCloudPlan = exports.plans = exports.planLabels = exports.cloudConfigPlans = void 0;
// used on organization.cloudConfig.plan
exports.cloudConfigPlans = [
    "Hobby",
    "Core",
    "Pro",
    "Team",
    "Enterprise",
];
exports.planLabels = {
    oss: "OSS",
    "cloud:hobby": "Hobby",
    "cloud:core": "Core",
    "cloud:pro": "Pro",
    "cloud:team": "Team",
    "cloud:enterprise": "Enterprise",
    "self-hosted:pro": "Pro (self-hosted)",
    "self-hosted:enterprise": "Enterprise (self-hosted)",
};
exports.plans = Object.keys(exports.planLabels);
// These functions are kept here to ensure consistency when updating plan names in the future.
const isCloudPlan = (plan) => plan?.startsWith("cloud");
exports.isCloudPlan = isCloudPlan;
const isSelfHostedPlan = (plan) => plan?.startsWith("self-hosted");
exports.isSelfHostedPlan = isSelfHostedPlan;
const isPlan = (value) => exports.plans.includes(value);
exports.isPlan = isPlan;
/**
 * ClickHouse Billing (CHB) identifies plans by code.
 *
 * Lives here rather than next to the Stripe catalogue in web because
 * `cloudConfigSchema` validates stored plan codes against it, and shared cannot
 * import from web.
 */
exports.chbPlanCodes = [
    "LANGFUSE_HOBBY",
    "LANGFUSE_CORE",
    "LANGFUSE_PRO",
    "LANGFUSE_PRO_TEAMS",
    "LANGFUSE_ENTERPRISE",
];
/**
 * Total mapping from CHB plan code to Langfuse plan. Total on purpose: callers
 * get an exhaustive lookup with no unmapped-code branch to handle, and adding a
 * code without a plan is a compile error.
 */
exports.chbPlanCodeToPlan = {
    LANGFUSE_HOBBY: "cloud:hobby",
    LANGFUSE_CORE: "cloud:core",
    LANGFUSE_PRO: "cloud:pro",
    LANGFUSE_PRO_TEAMS: "cloud:team",
    LANGFUSE_ENTERPRISE: "cloud:enterprise",
};
